import { render, staticRenderFns } from "./AnswerTypeLinearScale.vue?vue&type=template&id=41120617"
import script from "./AnswerTypeLinearScale.vue?vue&type=script&lang=js"
export * from "./AnswerTypeLinearScale.vue?vue&type=script&lang=js"
import style0 from "./AnswerTypeLinearScale.vue?vue&type=style&index=0&id=41120617&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports